export default __webpack_public_path__ + "static/media/portfolio-158.ce2a7095.jpg";